<template lang="pug">
  include ../../../../../views/desktop/shared/iconMixins.pug
  .color-satisfaction
    .survey(v-if="!hideSurvey")
      p.title.xs-f-xlarge.max-at-tweak What do you think of your color?

      hr

      .product-wrap
        p.prod-title.xs-f-xsmall.max-at-tweak.color-slate.upper {{ product.name }}

        p.prod-short-desc.xs-f-large.max-at-tweak {{ product.short_description }}

      .rating-wrap
        .rating-icon
          a(:href="rate(0)")
            +icon-face-sad

        .rating-icon
          a(:href="rate(1)")
            +icon-face-meh

        .rating-icon
          a(:href="rate(2)")
            +icon-face-like

        .rating-icon
          a(:href="rate(3)")
            +icon-face-love

      .havent-used
        button(@click="toggleSurvey()").btn-link.transparent-btn.xs-f-xsmall.max-at-tweak.color-mr-purple I haven't used my color yet.

    .survey-later(v-else)
      p.xs-f-small.max-at-tweak We are excited to hear about how your color turned out, we will check back soon.&nbsp;
      button(@click="toggleSurvey").btn-link.transparent-btn.xs-f-small.max-at-tweak Or you can rate it now.
  
</template>

<script>
  export default {
    name: 'ColorSatisfaction',

    data() {
      return {
        hideSurvey: false,
        colorSatCookie: 'HideColorSatSurvey'
      }
    },

    props: {
      invoiceId: {
        type: Number,
        required: true
      },

      product: Object,
      required: true
    },

    methods: {
      rate(rating) {
        return `/survey/color-satisfaction?oid=${this.invoiceId}&p=${this.product.id}&utm_campaign=color_satisfaction_survey_v3&rating=${rating}`
      },

      toggleSurvey(override) {
        //- we use this for url (/welcome?colorsurvey=not_colored#color-survey) from email to
        //- trigger the even Not Colored Yet Clicked which will initiate email workflow in Iterable
        if (typeof override == 'boolean') {
          this.hideSurvey = override;
        } else {
          this.hideSurvey = !this.hideSurvey;
        }

        this.$cookies.set(this.colorSatCookie, this.hideSurvey, '7d');
        //- if user clicks to hide this module track it
        if (this.hideSurvey) {
          this.trackEvent('Color Satisfaction - Not Colored Yet Clicked', {
            invoiceId: this.invoiceId,
            invoiceItems: [{
              product_id: this.product.id
            }]
          });
        }
      },

      readCookieOnMount() {
        this.hideSurvey = this.$cookies.get(this.colorSatCookie) == 'true';
      },

      readQueryParams() {
        if (this.$route.query.colorsurvey == 'not_colored') {
          this.toggleSurvey(true);
        }
      }
    },

    mounted() {
      this.readCookieOnMount();
      this.readQueryParams();
    }

  }
</script>

<style scoped lang="stylus">
  .color-satisfaction
    text-align center

    .survey
      .title
        width 10em;
        margin 0 auto

      > hr
        width 20em
        margin 1.5em auto
        border-top 1px solid color-fog-light

      .rating-wrap
        padding 0.7em 2em

      .rating-icon
        cursor pointer
        font-size 3em
        display inline-block

        svg
          width 1.4em

      .havent-used
        padding-bottom 1em

    .survey-later
      padding 0 3em

      button
        margin-top 0.5em

</style>
